/*
 * DATA_RIGHTS: HONEYWELL CONFIDENTIAL AND PROPRIETARY
 * THIS WORK CONTAINS VALUABLE CONFIDENTIAL AND PROPRIETARY
 * INFORMATION. DISCLOSURE, USE OR REPRODUCTION OUTSIDE OF
 * HONEYWELL INTERNATIONAL, INC. IS PROHIBITED EXCEPT AS
 * AUTHORIZED IN WRITING. THIS UNPUBLISHED WORK IS PROTECTED BY
 * THE LAWS OF THE UNITED STATES AND OTHER COUNTRIES. IN THE
 * EVENT OF PUBLICATION, THE FOLLOWING NOTICE SHALL APPLY:
 * Copyright (C) 2022 HONEYWELL INTERNATIONAL, INC., ALL RIGHTS RESERVED.
 *
 * Created by H144765 on 4/1/2022.
 */

import React from 'react';
import {withRouter} from "react-router-dom";
import connect from "react-redux/es/connect/connect";
import {bindActionCreators} from "redux";
import {goToAirtimeUrl} from '../api/Airtime'
import * as SecurityActions from "../security/SecurityActions";
import AirtimeAssetDetail from "./AirtimeAssetDetail"
import {Loader} from "@scuf/common";
import {verifyAirtimeException} from "../utils/Helpers";

class AirtimeDataLoader extends React.Component {
    constructor(props) {
        super(props);
        this.state= {
            loading: true,
            engineType: null,
            engineModel: null,
            assetName: null,
            asset: null,
            newFaultConditions: null,
            otherFaultConditions: null,
        }
    }

    componentDidMount(){
        this.parseCode()
    }

    changeLanguageLocal(lang) {
        localStorage.setItem('lang', lang);
    }

    parseCode() {
        if (this.props.location.state != null && this.props.location.state.sessionId != null) {
            const sessionId = this.props.location.state.sessionId
            goToAirtimeUrl(sessionId).then((response) => {
                    this.setState({
                        engineType: response.engineType,
                        engineModel: response.engineModel,
                        assetName: response.engineSerialNumber,
                        asset: response.asset,
                        newFaultConditions: response.newFaultConditions,
                        otherFaultConditions: response.otherFaultConditions,
                        loading: false,
                    })
                }
            ).catch(ex => {
                verifyAirtimeException(ex.errorKey, this.props.SecurityActions.signOut)
            })
        } else {
            this.props.SecurityActions.signOut();
        }
    }

    goToFault() {
        const {history} = this.props
        history.push('/airtime/asset/' + this.state.asset.id + '/faults/' + this.state.newFaultConditions[0].id)
    }

    goToFaults() {
        const {history} = this.props
        let notificationText

        if (this.state.newFaultConditions.length > 1) {
            notificationText = 'external.user.multiple.faults.created'
        } else {
            notificationText = 'external.user.no.fault.created'
        }

        history.push({
            pathname: '/faults',
            state: {notificationText: notificationText},
        })
    }

    render() {
        if (this.state.loading || this.state.asset === null) {
            return (
                <div>
                    <AirtimeAssetDetail
                        sessionId={this.props.location.state.sessionId}
                        asset={this.state.asset}
                        assetName={this.state.assetName}
                        engineType={this.state.engineType}
                        engineModel={this.state.engineModel}
                        setEngineType={(data) => this.setState({engineType: data, engineModel: null})}
                        setEngineModel={(data) => this.setState({engineModel: data})}
                        setAsset={(data) => this.setState({asset: data})}
                        setNewFaults={(data) => this.setState({newFaultConditions: data, loading: false})}
                        setLoading={(isLoading) => this.setState({loading: isLoading})}
                    />
                    <div className="airtime-data-loader">
                        <Loader text="Loading..." loading={this.state.loading}/>
                    </div>
                </div>
            )
        }

        return (
            <div>
                {this.state.newFaultConditions.length === 1 ?
                    this.goToFault()
                    :
                    this.goToFaults()
                }
            </div>
        )
    }
}

const mapStateToProps= state => {
    return {
        security: state.security,
    };
};

const mapDispatchToProps = dispatch => {
    return {
        SecurityActions: bindActionCreators(SecurityActions, dispatch),
    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(AirtimeDataLoader))